import http from 'axios'

export default {
  fetchCommercialisation: (username, anneeRecolte) => {
    return http.get(`/web/v1/${username}/recoltes/${anneeRecolte}/commercialisation`)
  }
}
